export default "__VITE_PUBLIC_ASSET__ab4fe7ce__"